import Vue from "vue";
import Vuex from "vuex";
import es6Promise from "es6-promise";
import axios from "axios";
import router from "./router";
import createPersistedState from "vuex-persistedstate";
es6Promise.polyfill();

Vue.use(Vuex);

// base defaults
const getDefaultState = () => {
  return {
    user: {
      full_name: "",
      first_name: "",
      email: "",
      isAdmin: ""
    },
    subscription: "",
    token: "",
    apiError: false,
    apiErrorMessage: "",
    property: {
      id: "1",
      name: "Store"
    }
  };
};

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;
// axios.defaults.baseURL = 'http://0.0.0.0:5000/api/';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// https://github.com/axios/axios
export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: getDefaultState(),
  mutations: {
    setUser(state, user) {
      state.user.full_name = user.full_name;
      state.user.first_name = user.first_name;
      state.user.email = user.email;
    },
    setToken(state, token) {
      // console.log('token ' + token);
      state.token = token;
    },
    setUserAndToken(state, user) {
      state.user.full_name = user.full_name;
      state.user.first_name = user.first_name;
      state.user.email = user.email;
      state.token = user.token;
      state.user.isAdmin = user.is_admin;
      state.apiError = false;
    },
    setAPIError(state, apiError) {
      state.apiError = apiError;
    },
    setAPIErrorAndMessage(state, data) {
      state.apiError = data.apiError;
      state.apiErrorMessage = data.apiErrorMessage;
    },
    setProperty(state, property) {
      state.property = property;
    },
    resetState(state) {
      Object.assign(state, getDefaultState());
    }
  },
  getters: {
    loggedIn(state) {
      return Boolean(state.token);
    },
    user: state => state.user,
    token: state => state.token,
    apiError: state => state.apiError,
    apiErrorMessage: state => state.apiErrorMessage,
    property: state => state.property
  },
  actions: {
    login: (context, payload) => {
      var config = {
        url: "/login",
        method: "get",
        auth: {
          username: payload.email,
          password: payload.password
        }
      };
      axios(config)
        .then(response => {
          context.commit("setUserAndToken", response.data.data);
          router.push("/console/main");
        })
        .catch(e => {
          // console.log(e);
          context.commit("setAPIErrorAndMessage", {
            apiError: true,
            apiErrorMessage: e.response.data.message
          });
          router.push("/console/login");
        });
    },
    logout: context => {
      context.commit("resetState");
      router.push("/console/login");
    },
    createUser: (context, payload) => {
      var config = {
        url: "/user",
        method: "post",
        headers: { "content-type": "application/json" },
        data: payload
      };
      axios(config)
        .then(response => {
          context.commit("setUserAndToken", response.data.data);
          router.push("/console/dashboard");
        })
        .catch(e => {
          // console.log(e);
          context.commit("setAPIErrorAndMessage", {
            apiError: true,
            apiErrorMessage: e.response.data.message
          });
        });
    },
    getUser: context => {
      var config = {
        url: "/user",
        method: "get",
        headers: {
          "x-access-token": context.state.token,
          "content-type": "application/json"
        }
      };
      axios(config)
        .then(response => {
          // console.log(response);
          context.commit("setUser", response.data.data);
        })
        .catch(e => {
          if (
            e.response.data &&
            e.response.data.message === "Token is invalid!"
          ) {
            context.commit("resetState");
            router.push("/console/login");
          }
        });
    },
    editUser: (context, payload) => {
      var config = {
        url: "/user",
        method: "put",
        headers: {
          "x-access-token": context.state.token,
          "content-type": "application/json"
        },
        data: payload
      };
      axios(config)
        .then(response => {
          context.commit("setAPIError", false);
          // console.log(response);
          router.push("/console/account/account");
        })
        .catch(e => {
          console.log(e);
          context.commit("setAPIErrorAndMessage", {
            apiError: true,
            apiErrorMessage: e.response.data.message
          });
        });
    },
    resetAllAPIErrorAndMessages: context => {
      context.commit("setAPIErrorAndMessage", false, "");
    },
    resetState: context => {
      context.commit("resetState");
    }
  }
});
